
class DBMappingMoreCell extends UITableViewCell
{
    activityIndicator:MUIActivityIndicatorView = null;
    awakeFromHTML(){
        this.activityIndicator = MUIOutlet(this, "activity-indicator", "MUIActivityIndicatorView");
        //this.activityIndicator.stopAnimating();
    }
}